<ng-container>
  <div id="report-container" class="spacer-power-bi-report-container"></div>
</ng-container>
